import { useMutation } from '@tanstack/react-query';
import { getAuthModule } from '../install';
export function useSignIn() {
    return useMutation({
        mutationFn: (input) => getAuthModule().actions.signIn(input),
    });
}
